import { Observable, ReplaySubject } from 'rxjs';
import { Inject, Injectable } from '@angular/core';
import { map, startWith } from 'rxjs/operators';
import { REVENUE_DEFAULT_CURRENCY_CODE_TOKEN } from './tokens';

@Injectable()
export class PotentialRevenueService {
  private readonly selectedDate$$ = new ReplaySubject<Date>(1);
  readonly selectedDate$ = this.selectedDate$$.asObservable().pipe(startWith(<Date>null));

  private readonly potentialRevenue$$ = new ReplaySubject<number>(1);
  readonly potentialRevenue$ = this.potentialRevenue$$.asObservable();

  private readonly weightedPotentialRevenue$$ = new ReplaySubject<number>(1);
  readonly weightedPotentialRevenue$ = this.weightedPotentialRevenue$$.asObservable();

  private readonly monthlyRevenue$$ = new ReplaySubject<number>(1);
  readonly monthlyRevenue$ = this.monthlyRevenue$$.asObservable();

  private readonly monthlyWeightedRevenue$$ = new ReplaySubject<number>(1);
  readonly monthlyWeightedRevenue$ = this.monthlyWeightedRevenue$$.asObservable();

  readonly isPotentialRevenueLoaded$ = this.potentialRevenue$.pipe(map((r) => !!r || r === 0));

  readonly currency$ = this.defaultCurrency$;

  constructor(@Inject(REVENUE_DEFAULT_CURRENCY_CODE_TOKEN) private readonly defaultCurrency$: Observable<string>) {}

  setDate(date: Date): void {
    this.selectedDate$$.next(date);
  }

  setPotentialRevenue(r: number): void {
    this.potentialRevenue$$.next(r);
  }

  setWeightedRevenue(r: number): void {
    this.weightedPotentialRevenue$$.next(r);
  }

  setMonthlyRevenue(r: number): void {
    this.monthlyRevenue$$.next(r);
  }

  setMonthlyWeightedRevenue(r: number): void {
    this.monthlyWeightedRevenue$$.next(r);
  }
}
